export default __webpack_public_path__ + "static/7-codepip-aa535ccddb01b91b1411a19afca1113a.png";